/* =============================================================
   WRIGHTSOCK — CTA Banner: product-page Add to Cart button
   Adds the current product's first available variant to the
   cart via AJAX, then opens the cart drawer (no page redirect).
   ============================================================= */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ws-cta-add-to-cart]');
    if (!button || button.hasAttribute('disabled')) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var textEl = button.querySelector('.ws-cta-add-to-cart-text');
    var originalText = textEl ? textEl.textContent : '';

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (textEl) textEl.textContent = window.variantStrings && window.variantStrings.addingToCart
      ? window.variantStrings.addingToCart
      : 'Adding…';

    var body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: cart ? cart.getSectionsToRender().map(function (section) { return section.id; }) : undefined,
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: body,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          console.error(response.message || response.description || 'Add to cart failed');
          return;
        }
        if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (textEl) textEl.textContent = originalText;
      });
  });
})();
